module.exports = __webpack_public_path__ + "21a902423b11578f30995bfdf04c66bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/footer/smh_hi_res_80percent.png
// module id = 865
// module chunks = 0